/** @graphql agg **/
import gql from 'graphql-tag';
import { graphql } from 'react-relay';

// TODO CCT: when we clean up the contentId based urls FF, move this to the whiteboardUnifiedQuery
export const SpaceQuery = gql`
	query SpaceQuery($spaceKey: String) {
		space(key: $spaceKey) {
			id
			name
			icon {
				path
			}
			homepage {
				id
			}
		}
	}
`;

export const SpaceQuery_Relay = graphql`
	query SpaceQuery($spaceKey: String) {
		space(key: $spaceKey) {
			id
			name
			icon {
				path
			}
			homepage {
				id
			}
		}
	}
`;
